// tslint:disable
export enum LayoutCategory {
    /**
     * @description Correspondence
     */
    COR = 1,
    /**
     * @description Expedited Patient Enroll Form
     */
    ERR = 2,
    /**
     * @description Patient Authorization Form
     */
    PAF = 3,
    /**
     * @description PASS Form
     */
    PAS = 4,
    /**
     * @description Patient Enrollment Form
     */
    PEF = 5,
    /**
     * @description Service Request Form
     */
    SRF = 6,
    /**
     * @description Patient Enrollment Form (XIF0033)
     */
    PEFXIF0033 = 9,
    /**
     * @description Income
     */
    INC = 12,
    /**
     * @description Claim
     */
    CLM = 14,
}
